<div class="jumbotron">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-header">
            Profile
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">{{user?.username}}</li>
            <li class="list-group-item">{{user?.email}}</li>
            <li class="list-group-item">{{user?.phone}}</li>
            <li class="list-group-item">{{user?.role}}</li>
          </ul>
          @if (employee) {
            <ul class="list-group list-group-flush">
              <li class="list-group-item">{{employee?.name}}</li>
              <li class="list-group-item">{{employee?.status}}</li>
              <li class="list-group-item">{{employee?.id_expiry_date}}</li>
              <li class="list-group-item">{{employee?.basic_salary}}</li>
            </ul>
          }
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <!-- <div class="card">
        <div class="card-header">
          My Status
        </div>
        <div class="card-body">

        </div>
      </div>
      <br> -->
      <div class="card">
        <div class="card-header">
          Actions
        </div>
        <div class="card-body">
          <li class="list-group-item">
            <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group">
              <button type="button" class="btn btn-secondary"
                (click)="changeP(content3, user)"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                <path
                  d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" />
                <path
                  d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" />
              </svg> Change Password
            </button>
            <!-- <button *ngIf="api.canEnter(['admin', 'doctor'])" type="button"
            (click)="open(contentSlot)" class="btn btn-success"><svg
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-calendar-week" viewBox="0 0 16 16">
            <path
              d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
            <path
              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
          </svg> Book Slots
        </button>
        <button *ngIf="api.canEnter(['admin', 'doctor'])" type="button"
          [routerLink]="['/doctor-calendar']" [queryParams]="{ id: employee?.id}"
          (click)="saveDoctor(employee)" class="btn btn-info"><svg
          xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-calendar-week" viewBox="0 0 16 16">
          <path
            d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
          <path
            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
        </svg> Check My Calender
      </button> -->
    </div>
    <!-- <button type="button" class="btn btn-info mx-2" style="color: white;" (click)="applyLeave()">
    <svg width="16" height="16" viewBox="0 0 1024 1024" class="icon" version="1.1"
      xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M106.666667 810.666667V298.666667h810.666666v512c0 46.933333-38.4 85.333333-85.333333 85.333333H192c-46.933333 0-85.333333-38.4-85.333333-85.333333z"
        fill="#FFCDD2"></path>
        <path
          d="M917.333333 213.333333v128H106.666667v-128c0-46.933333 38.4-85.333333 85.333333-85.333333h640c46.933333 0 85.333333 38.4 85.333333 85.333333z"
        fill="#F44336"></path>
        <path d="M704 213.333333m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
        fill="#B71C1C"></path>
        <path d="M320 213.333333m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
        fill="#B71C1C"></path>
        <path
          d="M704 64c-23.466667 0-42.666667 19.2-42.666667 42.666667v106.666666c0 23.466667 19.2 42.666667 42.666667 42.666667s42.666667-19.2 42.666667-42.666667V106.666667c0-23.466667-19.2-42.666667-42.666667-42.666667zM320 64c-23.466667 0-42.666667 19.2-42.666667 42.666667v106.666666c0 23.466667 19.2 42.666667 42.666667 42.666667s42.666667-19.2 42.666667-42.666667V106.666667c0-23.466667-19.2-42.666667-42.666667-42.666667z"
        fill="#BDBDBD"></path>
        <path
          d="M473.6 753.066667c0-4.266667 0-10.666667 2.133333-14.933334 2.133333-4.266667 4.266667-8.533333 8.533334-10.666666s6.4-6.4 10.666666-6.4c4.266667-2.133333 10.666667-2.133333 14.933334-2.133334s10.666667 0 14.933333 2.133334l12.8 6.4c4.266667 2.133333 6.4 6.4 8.533333 10.666666 2.133333 4.266667 2.133333 8.533333 2.133334 14.933334 0 4.266667 0 10.666667-2.133334 14.933333-2.133333 4.266667-4.266667 8.533333-8.533333 10.666667-4.266667 2.133333-6.4 6.4-12.8 6.4s-6.4 4.266667-12.8 4.266666-10.666667 0-14.933333-2.133333c-4.266667-2.133333-8.533333-4.266667-10.666667-6.4-4.266667-2.133333-6.4-6.4-8.533333-10.666667-2.133333-6.4-4.266667-10.666667-4.266667-17.066666z m66.133333-91.733334h-55.466666l-8.533334-234.666666h70.4l-6.4 234.666666z"
        fill="#F44336"></path>
      </g>
    </svg>
    Apply Leave
  </button> -->
</div>
</div>
</div>
</div>
</div>
</div>
<ng-template #content3 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Reset Password</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="email">email</label>
      <input type="text" class="form-control" [(ngModel)]="user_password.email" id="email" disabled>
    </div>
    <div class="mb-3">
      <label class="form-label" for="password">New Password</label>
      <input type="password" class="form-control" [(ngModel)]="user_password.password" id="password"
        placeholder="add password">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="OnChangePassword(user_password.id)">Submit</button>
  </div>
</ng-template>

<ng-template #contentSlot let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">My Calender Slots</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label class="form-label">My Booked Slots</label>
          <div class="card">
            <div class="card-body table-wrapper">
              <table class="table">
                <tr>
                  <td>date</td>
                  <td colspan="2">time</td>
                  <td>Reason</td>
                </tr>
                @for (slot of slots; track slot) {
                  <tr>
                    <td>{{slot.date_time | date:'dd/MM/yyyy'}}</td>
                    <td>{{slot.date_time | date:'hh:mm a'}}</td>
                    <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                    <td>{{slot.reason}}</td>
                  </tr>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="date" class="form-label">Date</label>
          <input type="datetime-local" class="form-control" id="date" [(ngModel)]="slot.date">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="period" class="form-label">Period</label>
          <input type="number" class="form-control" [(ngModel)]="slot.period" id="period">
        </div>
      </div>
      <div class="mb-3">
        <label for="reason" class="form-label">Booked Reason</label>
        <textarea class="form-control" [(ngModel)]="slot.reason" id="reason" rows="2" cols="50"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="createSlot()">Add</button>
  </div>
</ng-template>